import { useEffect, useState } from "react";
import { Tabs, TabsList, TabsTrigger } from "../ui/tabs";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Button } from "../ui/button";
import { Calendar } from "lucide-react";
import { Calendar as CalendarComponent } from '@/components/ui/calendar';
import DayTab from "../campaignComponent/DayTab";

type RangeType = 'today' | '7days' | '30days' | 'custom' | 'all'

interface AnalysisDashboardHeaderProps {
  timeRange: string
  setTimeRange: (range: string, startDate?: string, endDate?: string) => void
}

/**
 * AnalysisDashboardHeader component
 *
 * This component renders a header for the analysis dashboard page.
 * It includes a date range picker and a button to submit the selected range.
 *
 * @component
 * @returns {JSX.Element} The rendered analysis dashboard header component.
 * @author uplSouvik
 */

const AnalysisDashboardHeader = ({ timeRange, setTimeRange }: AnalysisDashboardHeaderProps) => {

  return (
    <div className="flex items-center w-full ">
      <DayTab range={timeRange as RangeType} setRange={setTimeRange as any} />
    </div>
  );
}

export default AnalysisDashboardHeader;